export class UserBranch {
	branchId: string;
	branchName: string;

	constructor(branchId: string, branchName: string) {
		this.branchId = branchId;
		this.branchName = branchName;
	}
}